import React from "react";
import Footer from "./Footer";
import Header from "./Header";

const ComingSoon = () => {
  return (
    <>
      <Header></Header>
      <div className="mainContent">
        <div className="comingSoonWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2>Coming Soon</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </>
  );
};
export default ComingSoon;
